import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(auth)/(center)/sign-up/layout.tsx");
